<template>
  <div
    class="history-modal-card history-modal-card modal-card"
    style="width: auto"
  >
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <section class="modal-card-body">
      <div class="field-history-pagination pagination-wrapper">
        <div class="pagination-header">
          <b-button
            v-show="showFhistoricalPreviousButton"
            @click="
              fhistoricalPageIndex = fhistoricalPageIndex - 1;
              getFieldsHistory(tabName, submissionId);
            "
            >Previous</b-button
          >
          <b-button
            class="apply-filter"
            v-show="showFhistoricalFirstButton"
            @click="
              fhistoricalPageIndex = 1;
              getFieldsHistory(tabName, submissionId);
            "
            >First</b-button
          >
          <span class="page-index"
            >{{ minFhistoricalPageIndex }} to {{ maxFhistoricalPageIndex }} of
            {{ fhistoricalTotalResults }}</span
          >
          <b-button
            v-show="showFhistoricalLastButton"
            @click="
              fhistoricalPageIndex = fhistoricalTotalPages;
              getFieldsHistory(tabName, submissionId);
            "
            >Last</b-button
          >
          <b-button
            class="apply-filter"
            v-show="fhistoricalShowNextButton"
            @click="
              fhistoricalPageIndex = fhistoricalPageIndex + 1;
              getFieldsHistory(tabName, submissionId);
            "
            >Next</b-button
          >
          <span class="page-navigator" v-show="fhistoricalTotalResults > 10"
            ><span class="show-text">Show</span
            ><b-select
              class="page-display-number"
              v-model="numberOfFhistoricalItemsPerPage"
              @input="
                fhistoricalPageIndex =
                  Math.floor(
                    minFhistoricalPageIndex / numberOfFhistoricalItemsPerPage
                  ) + 1;
                getFieldsHistory(tabName, submissionId);
              "
              ><option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </b-select></span
          >
        </div>
      </div>
      <b-table :data="historicalData" :columns="columns" focusable> </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
// import submissionFormView from "../views/SubmissionFormView.vue";
export default {
  name: "SubmissionFieldsHistory",
  props: ["tabName", "submissionId"],
  data() {
    return {
      columns: [
        { field: "vcat", label: "Catalog Number" },
        { field: "columnName", label: "Column Name" },
        { field: "fromValue", label: "From" },
        { field: "toValue", label: "To" },
        { field: "updatedBy", label: "Updated By" },
        { field: "updatedDate", label: "Updated Date" }
      ],
      isLoading: false,
      historicalData: [],
      fhistoricalPageIndex: 1,
      minFhistoricalPageIndex: "",
      maxFhistoricalPageIndex: "",
      fhistoricalTotalResults: "",
      fhistoricalTotalPages: "",
      showFhistoricalPreviousButton: true,
      fHistoricalEntityName: "",
      fhistoricalShowNextButton: true,
      showFhistoricalFirstButton: true,
      showFhistoricalLastButton: true,
      numberOfFhistoricalItemsPerPage: 10,
      isComponentFieldsModalActive: false
    };
  },
  mounted() {
    this.getFieldsHistory(this.tabName, this.submissionId);
  },
  methods: {
    getFieldsHistory(tabName, submissionId) {
      var fieldHistoryScope = this;
      fieldHistoryScope.fHistoricalEntityName = tabName;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      fieldHistoryScope.isLoading = true;
      fieldHistoryScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getHistoricalData?submissionId=${submissionId}&entityName=${fieldHistoryScope.fHistoricalEntityName}&pageNbr=${fieldHistoryScope.fhistoricalPageIndex}&pageSize=${fieldHistoryScope.numberOfFhistoricalItemsPerPage}`,
          null,
          args
        )
        .then(function(response) {
          fieldHistoryScope.isLoading = false;
          response.data.startIndex
            ? (fieldHistoryScope.minFhistoricalPageIndex =
                response.data.startIndex)
            : (fieldHistoryScope.minFhistoricalPageIndex = 0);
          response.data.endIndex
            ? (fieldHistoryScope.maxFhistoricalPageIndex =
                response.data.endIndex)
            : (fieldHistoryScope.maxFhistoricalPageIndex = 0);
          response.data.totalCount
            ? (fieldHistoryScope.fhistoricalTotalResults =
                response.data.totalCount)
            : (fieldHistoryScope.fhistoricalTotalResults = 0);
          response.data.totalPages !== undefined
            ? (fieldHistoryScope.fhistoricalTotalPages =
                response.data.totalPages)
            : (fieldHistoryScope.fhistoricalTotalPages = 0);
          if (response.data.startIndex <= 1) {
            fieldHistoryScope.showFhistoricalPreviousButton = false;
            fieldHistoryScope.showFhistoricalFirstButton = false;
          } else {
            fieldHistoryScope.showFhistoricalPreviousButton = true;
            fieldHistoryScope.showFhistoricalFirstButton = true;
          }
          if (
            fieldHistoryScope.fhistoricalPageIndex >=
            fieldHistoryScope.fhistoricalTotalPages
          ) {
            fieldHistoryScope.fhistoricalShowNextButton = false;
            fieldHistoryScope.showFhistoricalLastButton = false;
          } else {
            fieldHistoryScope.fhistoricalShowNextButton = true;
            fieldHistoryScope.showFhistoricalLastButton = true;
          }
          fieldHistoryScope.historicalData =
            response.data.newItemFieldsHistoryTbs;
        })
        .catch(function(error) {
          fieldHistoryScope.isLoading = false;
          fieldHistoryScope.$buefy.dialog.alert({
            message: `Failed to load Fields history for Submission ID - ${fieldHistoryScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    }
  }
};
</script>
